<ui-confirmation-dialog
    header="time-tracking.confirmAction"
    primaryButtonLabel="delete"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    #confirmDeleteModal
>
    <p>{{ 'time-tracking.confirmDeleteProject' | appTranslate }}</p>
</ui-confirmation-dialog>

<ui-confirmation-dialog
    header="time-tracking.confirmAction"
    primaryButtonLabel="archive"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    #confirmArchiveModal
>
    <ui-banner
        *ngIf="timeTrackingProject?.hasPendingTimesheetEntries"
        class="banner margin-bottom-2 align-left"
        variant="warning"
    >
        <p>{{ 'time-tracking.pendingHoursOnProjectArchive' | appTranslate }}</p>
    </ui-banner>
    <p [innerHTML]="'time-tracking.confirmArchiveProject' | appTranslate"></p>
</ui-confirmation-dialog>

<ui-confirmation-dialog
    header="time-tracking.projectCannotBeDeleted"
    primaryButtonLabel="close"
    secondaryButtonLabel="archive"
    secondaryButtonType="outline"
    #archiveInsteadModal
>
    <p>{{ 'time-tracking.projectCannotBeDeletedExplainerLine1' | appTranslate }}</p>
    <p>{{ 'time-tracking.projectCannotBeDeletedExplainerLine2' | appTranslate }}</p>
</ui-confirmation-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        [title]="timeTrackingProject.name"
        [back]="true"
        backRoute="/time-tracking/projects"
        [contextMenu]="showContextMenu"
        contextMenuType="material"
        [badgeOptions]="headerBadgeOptions()"
    >
        <div *ngIf="isAdmin && timeTrackingProject.isArchived" class="buttons">
            <ui-button type="primary" (click)="markAsActive()">
                {{ 'time-tracking.markAsActive' | appTranslate }}
            </ui-button>
        </div>
        <button *ngIf="!timeTrackingProject.isArchived" mat-menu-item (click)="onEdit()">
            {{ 'edit' | appTranslate }}
        </button>
        <button *ngIf="isAdmin && !timeTrackingProject.isArchived" mat-menu-item (click)="archiveProject()">
            {{ 'archive' | appTranslate }}
        </button>
        <button *ngIf="isAdmin" mat-menu-item (click)="onDelete()">{{ 'delete' | appTranslate }}</button>
    </app-header>

    <ui-banner
        *ngIf="timeTrackingProject.approvalFlow === 'owner' && owners.length === 0"
        class="banner margin-bottom-2 align-left"
        variant="warning"
    >
        <p>{{ 'time-tracking.showProjectPage.noOwners' | appTranslate }}</p>
    </ui-banner>

    <ui-card>
        <app-segment-header title="{{ 'time-tracking.generalInformation' | appTranslate }}"></app-segment-header>
        <div class="app-grid margin-bottom-4">
            <div class="columns-2 xl-columns-5 xxl-columns-4">
                <label>{{ 'time-tracking.showProjectPage.projectName' | appTranslate }}:</label>
            </div>
            <div class="columns-7">{{ timeTrackingProject.name }}</div>
        </div>
        <div class="app-grid margin-bottom-4">
            <div class="columns-2 xl-columns-5 xxl-columns-4">
                <label>{{ 'time-tracking.showProjectPage.projectDescription' | appTranslate }}:</label>
            </div>
            <div class="columns-7">{{ timeTrackingProject.description }}</div>
        </div>
        <div class="app-grid margin-bottom-4">
            <div class="columns-2 xl-columns-5 xxl-columns-4">
                <label>{{ 'time-tracking.showProjectPage.dateCreated' | appTranslate }}:</label>
            </div>
            <div class="columns-7">{{ timeTrackingProject.createdAt | i18nDate: 'short' }}</div>
        </div>
        <hr class="margin-bottom-4" />
        <div class="app-grid margin-bottom-4">
            <div class="columns-2 xl-columns-5 xxl-columns-4">
                <label>{{ 'time-tracking.showProjectPage.approvedHours' | appTranslate }}:</label>
            </div>
            <div class="columns-7">
                {{ minutesToHoursAndMinutes(timeTrackingProject.timesheetsApprovedSumMinutes) }}
            </div>
        </div>
        <div class="app-grid margin-bottom-4">
            <div class="columns-2 xl-columns-5 xxl-columns-4">
                <label>{{ 'time-tracking.showProjectPage.approvalFlow' | appTranslate }}:</label>
            </div>
            <div class="columns-7">{{ approvalFlows[timeTrackingProject.approvalFlow] | appTranslate }}</div>
        </div>
        <div class="app-grid margin-bottom-4" *ngIf="isOwnerApprovalFlow()">
            <div class="columns-2 xl-columns-5 xxl-columns-4">
                <label>{{ 'time-tracking.showProjectPage.projectOwners' | appTranslate }}:</label>
            </div>
            <div class="columns-7">
                <ng-container *ngIf="owners.length === 0">-</ng-container>
                <span *ngFor="let owner of owners; last as isLast">
                    <a [routerLink]="['/employees', 'directory', owner.id]">{{ owner.fullName }}</a>
                    <ng-container *ngIf="!isLast">, </ng-container>
                </span>
            </div>
        </div>
    </ui-card>

    <ui-card>
        <app-segment-header title="time-tracking.assignedEmployees"> </app-segment-header>

        <app-assign-employees-project-table
            [employees]="employees"
            [project]="timeTrackingProject"
            (onEmployeesChange)="projectEmployeeAssignments($event)"
            (onRemoveChange)="onDeleteAssignment($event)"
            [allowModification]="!timeTrackingProject.isArchived"
        ></app-assign-employees-project-table>
    </ui-card>
</div>
